export default __webpack_public_path__ + "static/media/icon-subscription-3.9e5b4f99.svg";